import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const getToken = () => {
    return localStorage.getItem('token');
  };
  const token = getToken();

export const getLeadOrigins = () => {
  return axios.get(`${API_URL}/lead-origins`,{
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
};

export const getLeadOriginById = (id) => {
  return axios.get(`${API_URL}/lead-origins/${id}`,{
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
};

export const createLeadOrigin = (data) => {
  return axios.post(`${API_URL}/lead-origins/`, data,{
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
};

export const updateLeadOrigin = (id, data) => {
  return axios.put(`${API_URL}/lead-origins/${id}`, data,{
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
};

export const deleteLeadOrigin = (id) => {
  return axios.delete(`${API_URL}/lead-origins/${id}`,{
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
};